import React, { useState } from 'react';
import {
  Modal,
  ModalOverlay,
  ModalContent,
  ModalHeader,
  ModalFooter,
  ModalBody,
  ModalCloseButton,
  Button,
  FormControl,
  FormLabel,
  Input,
  Textarea,
  FormErrorMessage,
  VStack,
  Alert,
  AlertIcon,
  AlertTitle,
  AlertDescription,
  useToast,
  Text,
  Select,
  FormHelperText,
  Box
} from '@chakra-ui/react';
import { useDispatch, useSelector } from 'react-redux';
import { submitFeedback } from '../../Redux/Ticket/userTicketActions';

const ReportIssue = ({ isOpen, onClose }) => {
  const dispatch = useDispatch();
  const toast = useToast();
  
  // Get submission state from Redux
  const { loading, error, fieldErrors } = useSelector(state => state.ticket?.submission || {});
  
  // Form state - use the same structure as FeedbackModal
  const [formData, setFormData] = useState({
    subject: '',
    message: ''
  });
  
  // Handle input changes
  const handleChange = (e) => {
    const { name, value } = e.target;
    setFormData({
      ...formData,
      [name]: value
    });
  };
  
  // Handle form submission
  const handleSubmit = async (e) => {
    if (e) e.preventDefault();
    
    const result = await dispatch(submitFeedback(formData));
    
    if (result.success) {
      toast({
        title: 'Feedback Submitted',
        description: 'Thank you for your feedback! Our team will look into it.',
        status: 'success',
        duration: 5000,
        isClosable: true,
      });
      onClose();
      // Reset form
      setFormData({
        subject: '',
        message: ''
      });
    }
  };
    return (
    <Modal isOpen={isOpen} onClose={onClose} size="lg">
      <ModalOverlay />
      <ModalContent>
        <ModalHeader>Feedback</ModalHeader>
        <ModalCloseButton />
        
        <ModalBody>
          {error && (
            <Alert status="error" mb={4}>
              <AlertIcon />
              <AlertTitle>Error!</AlertTitle>
              <AlertDescription>{error}</AlertDescription>
            </Alert>
          )}
          
          <form onSubmit={handleSubmit}>
            <VStack spacing={4}>
              <FormControl isRequired isInvalid={fieldErrors?.subject}>
                <FormLabel>Subject</FormLabel>
                <Input 
                  name="subject"
                  value={formData.subject}
                  onChange={handleChange}
                  placeholder="Briefly describe your feedback"
                />
                {fieldErrors?.subject && (
                  <FormErrorMessage>{fieldErrors.subject}</FormErrorMessage>
                )}
              </FormControl>
              
              <FormControl isRequired isInvalid={fieldErrors?.message}>
                <FormLabel>Your Feedback</FormLabel>
                <Textarea 
                  name="message"
                  value={formData.message}
                  onChange={handleChange}
                  placeholder="We'd love to hear your thoughts, suggestions, or concerns..."
                  rows={6}
                />
                {fieldErrors?.message && (
                  <FormErrorMessage>{fieldErrors.message}</FormErrorMessage>
                )}
              </FormControl>
            </VStack>
          </form>
        </ModalBody>
        
        <ModalFooter>
          <Button variant="ghost" mr={3} onClick={onClose}>
            Cancel
          </Button>
          <Button 
            colorScheme="blue"
            onClick={handleSubmit}
            isLoading={loading}
            loadingText="Submitting"
          >
            Submit Feedback
          </Button>
        </ModalFooter>
      </ModalContent>
    </Modal>
  );
};

export default ReportIssue;
